import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import Index from "./pages/Index";
import AIMusicFramework from "./pages/AIMusicFramework";
import CopyrightabilityEngine from "./pages/CopyrightabilityEngine";
import Pilot from "./pages/Pilot";
import About from "./pages/About";
import Contact from "./pages/Contact";
import JoinWaitlist from "./pages/JoinWaitlist";
import NotFound from "./pages/NotFound";

// ScrollToTop component to reset scroll position on route change
function ScrollToTop() {
  const { pathname } = useLocation();
  
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  
  return null;
}

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Index />} />
          <Route path="/ai-music-framework" element={<AIMusicFramework />} />
          {/* Keep the old route temporarily for backward compatibility */}
          <Route path="/ai-musicframework" element={<AIMusicFramework />} />
          <Route path="/copyrightability-engine" element={<CopyrightabilityEngine />} />
          <Route path="/pilot" element={<Pilot />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/join-waitlist" element={<JoinWaitlist />} />
          <Route path="/join-pilot" element={<Pilot />} />
          {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
